import { Shot } from "./Shot.tsx";

export function AlwaysRunning() {
  return (
    <section className="relative overflow-hidden px-6 py-24 sm:py-32">
      <div className="mx-auto grid w-full max-w-5xl items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div data-reveal="" style={{ ["--reveal-delay" as string]: "0ms" }}>
          <p className="font-mono text-xs tracking-wide text-muted-foreground/70">全屏倒计时</p>
          <h2 className="mt-4 text-balance text-4xl font-semibold tracking-tight sm:text-5xl">
            普通通知容易被忽略，全屏倒计时不会
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
            触发后覆盖桌面并开始倒计时，倒计时结束后自动退场。白名单命中会议、演示、剪辑等前台应用时自动跳过本轮，减少关键场景误打扰。
          </p>
        </div>
        <div data-reveal="" style={{ ["--reveal-delay" as string]: "100ms" }}>
          <Shot
            src="/overlay-countdown.png"
            alt="肛了么全屏倒计时提醒：喝口水，休息一下"
          />
        </div>
      </div>
    </section>
  );
}
